import { useMemo, useState } from "react";
import { IoIosSettings } from "react-icons/io";

import InfoTab from "./tabs/information/information-tab.component";
import PeopleTab from "./tabs/people/people-tab.component";
import NotesTab from "./tabs/notes/notes-tab.component";
import ArchiveTab from "./tabs/archive/archive-tab.component";
import SafeTab from "./tabs/safe/safe-tab.component";
import SettingsTab from "./tabs/settings/settings-tab.component";

import "./row-data.style.scss";

const RowData = ({ data, index }) => {
	const TABS = useMemo(
		() => ({
			info: {
				name: "Company Information",
				component: <InfoTab id={data.id} />,
			},
			people: {
				name: "People",
				component: <PeopleTab id={data.id} />,
			},
			notes: { name: "Notes", component: <NotesTab data={data} index={index} id={data.id} /> },
			archive: { name: "Archive", component: <ArchiveTab index={index} id={data.id} /> },
			safe: { name: "Safe", component: <SafeTab index={index} id={data.id} /> },
			settings: {
				name: <IoIosSettings />,
				component: <SettingsTab isPersonalAccount={data.companyType === 0} id={data.id} />,
			},
		}),
		[data, index]
	);

	const [selectedTab, setSelectedTab] = useState("info");

	const handleSelect = (tab) => {
		setSelectedTab(tab);
	};

	return (
		<div className="row-data-container">
			<div className="tab-bar unselectable">
				{Object.keys(TABS).map((tab, index) => {
					return (
						<div
							key={index}
							onClick={() => {
								handleSelect(tab);
							}}
							className={`size400 w500 tab-button ${tab === selectedTab && "selected"}`}
						>
							{TABS[tab].name}
						</div>
					);
				})}
			</div>
			{/* {selectedTab && TABS[selectedTab]?.component} */}
			<div className="tab-container scroll-bar scroll-bar--overflow">
				{TABS[selectedTab]?.component}
			</div>
		</div>
	);
};

export default RowData;
